import { ComponentPortal, Portal } from '@angular/cdk/portal';
import { ChangeDetectorRef, Component, ComponentRef, EventEmitter, OnInit } from '@angular/core';
import { RecognizedSupplierService } from 'src/app/modules/payable/services/recognized-supplier.service';
import { BillsToPaySupplierDetailsRequest } from '../models/invoice/bills-to-pay-invoice-details-request';

/**
 * The frame RecordPanelService puts a record's own side panel in. The panels are the ones the
 * rest of the app uses, unchanged: the bill panel from the inbox, the supplier panel from
 * Suppliers, the payment panel from Payments. Each carries its approval block.
 */
@Component({
  selector: 'app-record-panel-host',
  templateUrl: './record-panel-host.component.html',
  styleUrls: ['./record-panel-host.component.scss']
})
export class RecordPanelHostComponent implements OnInit {
  panelKey: string;
  recordId: string;
  readonly closed = new EventEmitter<void>();

  /** The bill panel narrows when the bill has no document to show beside the form. */
  hasDocument = true;
  /**
   * PaymentSidebarComponent belongs to PayableModule, which imports this one, so it is loaded
   * on demand rather than declared here.
   */
  paymentPortal: Portal<any> = null;

  constructor(private _suppliers: RecognizedSupplierService, private _cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.panelKey === 'supplier') {
      this._suppliers.sendSupplierToContactForm({ supplierId: this.recordId, invoiceColorNumber: 1 } as BillsToPaySupplierDetailsRequest);
    }
    if (this.panelKey === 'payment') {
      Promise.all([
        import('src/app/modules/payable/payable.module'),
        import('src/app/modules/payable/payment-sidebar/payment-sidebar/payment-sidebar.component')
      ]).then(([, m]) => {
        this.paymentPortal = new ComponentPortal(m.PaymentSidebarComponent);
        this._cdr.markForCheck();
      });
    }
  }

  onPaymentAttached(ref: ComponentRef<any>): void {
    // PaymentSideBarMode.Payments: the panel as the Payments page opens it.
    ref.instance.paymentSideBarMode = 1;
    ref.instance.paymentId = this.recordId;
    ref.instance.newItemEvent?.subscribe(() => this.close());
  }

  close(): void {
    this.closed.emit();
  }
}
